import React from 'react';
import KoobConfirmationModal from '@koob/ui/src/components/KoobConfirmationModal';
import type { Translate } from './types';

interface TripDayExperienceRemoveConfirmationModalProps {
  open: boolean;
  setOpen: (open: boolean) => void;
  onConfirm: () => void;
  experience: any;
  previousExperience: any;
  requiredExtras: string[];
  t: Translate;
}

export default function TripDayExperienceRemoveConfirmationModal({
  open,
  setOpen,
  onConfirm,
  experience,
  previousExperience,
  requiredExtras,
  t,
}: TripDayExperienceRemoveConfirmationModalProps) {
  return (
    <KoobConfirmationModal
      open={open}
      setOpen={setOpen}
      onConfirm={onConfirm}
      title={t('compose.extras.deleteRequiredOptionsWarningTitle')}
    >
      <div>
        <p className="text-sm leading-relaxed text-gray-600">
          {t('compose.extras.deleteRequiredOptionsWarning', {
            programName: experience?.name,
            previousProgramName: previousExperience?.name ?? '',
          })}
        </p>

        {requiredExtras.length > 0 && (
          <div className="mt-5">
            <p className="mb-2 text-xs font-semibold tracking-widest uppercase text-gray-400">
              {t('compose.extras.affectedExtras')}
            </p>
            <div className="rounded-xl border border-slate-100 bg-slate-50 divide-y divide-slate-100 overflow-hidden">
              {requiredExtras.map((name, idx) => (
                <div key={idx} className="flex items-center gap-3 px-4 py-3">
                  <span className="flex-shrink-0 w-2 h-2 rounded-full bg-amber-400" />
                  <span className="text-sm text-gray-700 font-medium">
                    {name}
                  </span>
                </div>
              ))}
            </div>
          </div>
        )}
      </div>
    </KoobConfirmationModal>
  );
}
